module.exports = __webpack_public_path__ + "img/icon-google.d45480e1.png";